
// export default PaymentStatusPage;
import React, { useState, useEffect } from 'react';
import appointmentService from '../../services/http/appointments/appointment.service';


interface PaymentStatusResponse {
    success: boolean;
    status: 'BOOKING_SUCCESS' | 'BOOKING_FAILED' | 'TRANSACTION_FAILED' | 'TRANSACTION_CANCELLED';
    orderId: string;
    transactionId?: string;
    amount: number;
    practitionerName: string;
    appointmentDate?: string;
    errorMessage?: string;
    message?: string;
    time?: string;
    statusName?: string; // For booking failed cases
}

const PaymentStatusPage = () => {
    const [statusData, setStatusData] = useState<PaymentStatusResponse | null>(null);
    const [loading, setLoading] = useState<boolean>(true);
    const [error, setError] = useState<string | null>(null);

    // Extract orderId from URL params or search params
    useEffect(() => {
        const urlParams = new URLSearchParams(window.location.search);
        const orderIdParam = urlParams.get('order_id');
        console.log('orderIdFromUrl', orderIdParam);
        if (orderIdParam) {
            checkPaymentStatus(orderIdParam);
        } else {
            setError('Order ID is required');
            setLoading(false);
        }
    }, []);

    const checkPaymentStatus = async (orderId: string) => {
        try {
            setLoading(true);

            const data: PaymentStatusResponse = await appointmentService.getCashfreeStatus(orderId);
            console.log('Payment status data:', data);

            if (data.success) {
                setStatusData(data);
            } else {
                setError(data.message || 'Failed to check payment status');
            }
        } catch (err) {
            setError('Unable to verify payment. Please contact support.');
            console.error('Payment status check error:', err);
        } finally {
            setLoading(false);
        }
    };

    // const formatDate = (dateString: string | undefined): string => {
    //     if (!dateString) return '';
    //     return new Date(dateString).toLocaleString('en-IN', {
    //         day: '2-digit',
    //         month: '2-digit',
    //         year: 'numeric',
    //         hour: '2-digit',
    //         minute: '2-digit',
    //     });
    // };

    const renderStatusIcon = (status: string | undefined) => {
        switch (status) {
            case 'BOOKING_SUCCESS':
                return (
                    <div style={{ textAlign: 'center' }}>
                        <div style={{ fontSize: '90px', color: '#3492C3', marginBottom: '0.5rem' }}>
                            ✓
                        </div>
                        <span style={{ color: '#3492C3', fontSize: '20px', fontWeight: '700' }}>
                            Successfully Booked
                        </span>
                    </div>
                );
            case 'BOOKING_FAILED':
                return (
                    <div style={{ textAlign: 'center' }}>
                        <div style={{ fontSize: '90px', color: 'red', marginBottom: '0.5rem' }}>
                            ✕
                        </div>
                        <span style={{ color: 'red', fontSize: '20px', fontWeight: '700' }}>
                            Failed Appointment Booking
                        </span>
                    </div>
                );
            case 'TRANSACTION_FAILED':
                return (
                    <div style={{ textAlign: 'center' }}>
                        <div style={{ fontSize: '90px', color: 'red', marginBottom: '0.5rem' }}>
                            ✕
                        </div>
                        <span style={{ color: 'red', fontSize: '20px', fontWeight: '700' }}>
                            Failed Appointment Booking
                        </span>
                    </div>
                );
            case 'TRANSACTION_CANCELLED':
                return (
                    <div style={{ textAlign: 'center' }}>
                        <div style={{ fontSize: '90px', color: 'red', marginBottom: '0.5rem' }}>
                            ✕
                        </div>
                        <span style={{ color: 'red', fontSize: '20px', fontWeight: '700' }}>
                            Transaction Dropped By User
                        </span>
                    </div>
                );
            default:
                return null;
        }
    };

    const getPageTitle = (status: string | undefined): string => {
        switch (status) {
            case 'BOOKING_SUCCESS':
                return 'Transaction Successful';
            case 'BOOKING_FAILED':
                return 'Appointment Failed';
            case 'TRANSACTION_FAILED':
                return 'Transaction Failed';
            case 'TRANSACTION_CANCELLED':
                return 'Transaction Cancelled';
            default:
                return 'Payment Status';
        }
    };

    const handleRetry = (): void => {
        window.location.reload();
    };

    // const handleRefreshStatus = (): void => {
    //     if (orderId) {
    //         checkPaymentStatus(orderId);
    //     }
    // };

    // const handleTryAgain = (): void => {
    //     window.history.back();
    // };

    // const handleBackToHome = (): void => {
    //     window.location.href = '/';
    // };

    if (loading) {
        return (
            <div style={{
                minHeight: '100vh',
                backgroundColor: '#f9fafb',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center'
            }}>
                <div style={{ textAlign: 'center' }}>
                    <div style={{
                        fontSize: '2.5rem',
                        marginBottom: '1rem',
                        animation: 'spin 1s linear infinite'
                    }}>
                        ⟳
                    </div>
                    <div style={{ fontSize: '1.125rem', color: '#6b7280' }}>
                        Checking payment status...
                    </div>
                </div>
            </div>
        );
    }

    if (error) {
        return (
            <div style={{
                minHeight: '100vh',
                backgroundColor: '#f9fafb',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center'
            }}>
                <div style={{
                    maxWidth: '28rem',
                    width: '100%',
                    backgroundColor: 'white',
                    borderRadius: '0.5rem',
                    boxShadow: '0 10px 15px -3px rgba(0, 0, 0, 0.1)',
                    padding: '2rem'
                }}>
                    <div style={{ textAlign: 'center' }}>
                        <div style={{ fontSize: '3.75rem', color: '#ef4444', marginBottom: '1rem' }}>
                            ⚠
                        </div>
                        <h2 style={{ fontSize: '1.5rem', fontWeight: 'bold', color: '#111827', marginBottom: '1rem' }}>
                            Error
                        </h2>
                        <p style={{ color: '#6b7280', marginBottom: '1.5rem' }}>{error}</p>
                        <button
                            onClick={handleRetry}
                            style={{
                                backgroundColor: '#3b82f6',
                                color: 'white',
                                fontWeight: 'bold',
                                padding: '0.5rem 1rem',
                                borderRadius: '0.25rem',
                                border: 'none',
                                cursor: 'pointer',
                                transition: 'background-color 0.2s'
                            }}
                            onMouseOver={(e: any) => e.target.style.backgroundColor = '#2563eb'}
                            onMouseOut={(e: any) => e.target.style.backgroundColor = '#3b82f6'}
                        >
                            Retry
                        </button>
                    </div>
                </div>
            </div>
        );
    }

    return (
        <div style={{ minHeight: '100vh', backgroundColor: '#f9fafb' }}>
            <style>{`
        @keyframes spin {
          from { transform: rotate(0deg); }
          to { transform: rotate(360deg); }
        }
      `}</style>

            <div className="container" style={{ maxWidth: '1200px', margin: '0 auto', padding: '15px' }}>
                <div className="row" style={{ display: 'flex', justifyContent: 'center' }}>
                    <div className="col-lg-4"></div>
                    <div className="col-lg-4 col-md-12 col-sm-12 col-12" style={{ padding: '15px 0px 0px 0px' }}>

                        {/* Logo */}
                        <div style={{ marginBottom: '15px', textAlign: 'center' }}>
                            <img
                                src="/img/logo-transparent.png"
                                alt="Schedula"
                                style={{ height: '50px' }}
                                onError={(e: any) => {
                                    e.target.style.display = 'none';
                                }}
                            />
                        </div>

                        {/* Title */}
                        <div style={{ textAlign: 'center' }}>
                            <div>
                                <h3>{getPageTitle(statusData?.status)}</h3>
                            </div>

                            {/* Status Content */}
                            <div id="booked">
                                {renderStatusIcon(statusData?.status)}
                                <br />
                                <span style={{ color: '#545454', fontSize: '16px', fontWeight: '700' }}>
                                    Regular Consultation
                                </span>
                                <br />
                                <span style={{ color: '#545454', fontSize: '16px', fontWeight: '700' }}>
                                    With{' '}
                                </span>
                                <span id="dname">Dr. {statusData?.practitionerName}</span>

                                {/* Show status for booking failed and transaction cancelled */}
                                {(statusData?.status === 'BOOKING_FAILED' && statusData?.statusName) && (
                                    <>
                                        <br />
                                        <span style={{ color: '#545454', fontSize: '16px', fontWeight: '700' }}>
                                            Status: {statusData.statusName}
                                        </span>
                                    </>
                                )}
                            </div>
                        </div>

                        {/* Transaction Details */}
                        <div style={{
                            border: '1px solid #f9f9f9',
                            borderRightColor: 'transparent',
                            padding: '10px 0',
                            borderLeftColor: 'transparent',
                            marginBottom: '20px',
                            textAlign: 'center'
                        }}>
                            {/* <div style={{ margin: '5px 0' }}>
                                <span>
                                    <div style={{ textAlign: 'center' }}>
                                        <span style={{ marginRight: '4px' }}>₹</span>
                                        <span id="money">{statusData?.amount}</span>
                                    </div>
                                    {statusData?.status === 'BOOKING_SUCCESS' && (
                                        <span
                                            id="paidbox"
                                            style={{
                                                border: '1px solid #29b52e',
                                                color: '#29b52e',
                                                padding: '0 5px',
                                                borderRadius: '4px',
                                                display: 'inline-block',
                                                marginTop: '5px',
                                                visibility: statusData?.status === 'BOOKING_SUCCESS' ? 'visible' : 'hidden'
                                            }}
                                        >
                                            Paid
                                        </span>
                                    )}
                                </span>
                            </div> */}

                            {/* Transaction ID and Time - only for transactions with ID */}
                            {statusData?.transactionId && statusData?.status !== 'TRANSACTION_CANCELLED' && (
                                <>
                                    <span style={{ color: '#7c7c7c' }}>Transaction ID: </span>
                                    <span id="taxnid" style={{ color: '#404040' }}>{statusData.transactionId}</span>
                                    <br />
                                    {statusData?.time && (
                                        <span id="transdate" style={{ color: '#7c7c7c' }}>{statusData.time}</span>
                                    )}
                                </>
                            )}
                        </div>

                        {/* Support Information */}
                        <div style={{ padding: '0px 20px' }}>
                            {statusData?.status === 'BOOKING_SUCCESS' ? (
                                <span style={{ color: '#727272' }}>
                                    For any technical queries, contact <i>Schedula Services</i> at 04448133022 or email to support@schedula.in
                                </span>
                            ) : (
                                <ol className="directions">
                                    <li style={{ color: '#727272' }}>
                                        For any technical queries, contact <i>Schedula Services</i> at 04448133022 or email to support@schedula.in
                                    </li>
                                </ol>
                            )}
                        </div>

                        {/* Action Buttons
            <div style={{ textAlign: 'center', marginTop: '20px' }}>
              {(statusData?.status === 'BOOKING_FAILED' || 
                statusData?.status === 'TRANSACTION_FAILED' || 
                statusData?.status === 'TRANSACTION_CANCELLED') && (
                <button
                  onClick={handleTryAgain}
                  style={{
                    backgroundColor: '#3b82f6',
                    color: 'white',
                    fontWeight: 'bold',
                    padding: '0.5rem 1.5rem',
                    borderRadius: '0.25rem',
                    border: 'none',
                    cursor: 'pointer',
                    marginRight: '0.75rem',
                    transition: 'background-color 0.2s'
                  }}
                  onMouseOver={(e:any) => e.target.style.backgroundColor = '#2563eb'}
                  onMouseOut={(e:any) => e.target.style.backgroundColor = '#3b82f6'}
                >
                  Try Again
                </button>
              )}
              
              <button
                onClick={handleBackToHome}
                style={{
                  color: '#2563eb',
                  fontWeight: '500',
                  background: 'none',
                  border: 'none',
                  cursor: 'pointer',
                  transition: 'color 0.2s',
                  fontSize: '1rem'
                }}
                onMouseOver={(e:any) => e.target.style.color = '#1e40af'}
                onMouseOut={(e:any) => e.target.style.color = '#2563eb'}
              >
                ← Back to Home
              </button>
            </div> */}
                    </div>
                    <div className="col-lg-4"></div>
                </div>
            </div>
        </div>
    );
};

export default PaymentStatusPage;